import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
	Button,
	TextField,
	MuiThemeProvider,
	createTheme
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { deleteLanguage, getLanguageById, postLanguage, updateLanguage } from '../../../../api/language'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

// Create theme for delete button (red)
const theme = createTheme({
	palette: {
		secondary: {
			main: '#F64E60'
		}
  }
})

function getEmptyLanguage() {
  return {
    fullName: '',
    isocode: ''
  }
}

export default function EditLanguagesPage() {
  const [language, setLanguage] = useState(getEmptyLanguage())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const languageId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!languageId) {
      disableLoadingData()
      return
    }
    getLanguageById(languageId).then(res => {
      if (res.status === 200) {
        setLanguage(res.data)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'No se ha podido obtener el idioma.' })
      history.push('/languages')
    })
  }, [languageId, disableLoadingData, history])

  function saveLanguage() {
    if (!languageId) {
      postLanguage(language).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: 'Guardado!', customMessage: 'Idioma creado correctamente.' })
          history.push('/languages')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se ha podido guardar el idioma.' })
      })
    } else {
      updateLanguage(languageId, language).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Guardado!', customMessage: 'Cambios guardados correctamente.' })
          history.push('/languages')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se han podido guardar los cambios.' })
      })
    }
  }

  const handleChange = (element) => (event) => {
    setLanguage({ ...language, [element]: event.target.value })
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Editar idioma'>
        </CardHeader>
        <CardBody>
          <TextField
            id={`fullName`}
            label="Full name"
            value={language.fullName}
            onChange={handleChange('fullName')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`isocode`}
            label="ISO code"
            value={language.isocode}
            onChange={handleChange('isocode')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
            disabled={languageId}
          />
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/languages')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Atrásss
      </Button>
      <Button
        onClick={() => saveLanguage()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Guardar idioma
      </Button>
      {languageId && language.isocode !== 'es' && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Eliminar idioma
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'Seguro que quieres eliminar este idioma?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteLanguage(languageId).then(res => {
              if (res.status === 204 || res.status === 200) {
                alertSuccess({ title: 'Eliminado!', customMessage: 'Idioma eliminado correctamente.' })
                history.push('/languages')
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'No se ha podido eliminar el economic sector.' })
            })
          }}
        />
      </>}
    </>
  );
}
